import React from 'react';
import './ApplicationCardSkeleton.scss';

const ApplicationCardSkeleton: React.FC = () => {
  return (
    <div className="application-card-skeleton">
      <div className="application-card-skeleton__header">
        <div className="skeleton skeleton--name"></div>
        <div className="skeleton skeleton--icon"></div>
      </div>
      <div className="skeleton skeleton--date"></div>
      <div className="skeleton skeleton--subscriptions"></div>
    </div>
  );
};

export default ApplicationCardSkeleton;
